import Page from "components/Page";
import React from "react";
import styles from "./../../../ManageSystemInstructions/SystemInstruction.module.scss";
import { withTranslation } from "react-i18next";
import constants from "./../../../../../../constants";
import Card from "components/Card";
import { decodeId, formatLocalDateTime } from "utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Text from "components/Text";

function ViewPromptDetail({ t, location, history }) {
  const { selectedData } = location?.state;
  let { promptId } = useParams();
  promptId = decodeId(promptId);

  const goBack = () =>
    history.push({ pathname: constants.routes.aiAssistant.managePrompts });

  return (
    <>
      <Page
        onBack={() => goBack()}
        className={styles["global-main-page"]}
        title={t("aiAssistant.viewPrompt")}
      >
        <div className={styles["new-instruction-messages"]}>
          <Card radius="10px" className={styles["instruction-card"]}>
            <div className={styles["input-wrapper"]}>
              <Text size="0.8125rem" weight="400" color="#79869a">
                {t("aiAssistant.addPrompt.promptName")}
              </Text>
              <Text
                size="0.875rem"
                weight="600"
                color="#102c42"
                paddingBottom="15px"
                borderBottom="1px solid #ddd"
                marginBottom="30px"
              >
                {selectedData?.promptName}
              </Text>
              <Text size="0.8125rem" weight="400" color="#79869a">
                {t("aiAssistant.updatedOn")}
              </Text>
              <Text
                size="0.875rem"
                weight="600"
                color="#102c42"
                paddingBottom="15px"
                borderBottom="1px solid #ddd"
                marginBottom="30px"
              >
                {formatLocalDateTime(selectedData?.createdAt, "MMM DD, YYYY")}
              </Text>
              <Text size="0.8125rem" weight="400" color="#79869a">
                {t("aiAssistant.addPrompt.describePrompt")}
              </Text>
              <Text
                size="0.875rem"
                weight="600"
                color="#102c42"
                paddingBottom="30px"
                borderBottom="1px solid #ddd"
              >
                {selectedData?.description}
              </Text>
            </div>
          </Card>
        </div>
      </Page>
    </>
  );
}

export default withTranslation()(ViewPromptDetail);
